<template>
  <div class="profile-user">
    <div class="container">
      <div class="d-flex justify-content-end mb-1">
        <b-button
          size="sm"
          variant="outline-primary"
          :to="{ name: 'zerg-menu' }"
        >
          <feather-icon icon="CornerUpLeftIcon"></feather-icon>
          {{ $t('Back to Home') }}
        </b-button>
      </div>
      <b-row>
        <b-col xl="3" lg="3" md="4" sm="6" cols="12" class="sticky">
          <user-information :user-id="dataUser.id"></user-information>
          <user-qr v-if="dataUser.personal_type == 'Employee'" :user-id="dataUser.employee_id"></user-qr>
          <driver-information v-else :employee-id="dataUser.employee_id"></driver-information>
        </b-col>
        <b-col xl="9" lg="9" md="8" sm="6" cols="12">
          <user-time-balance></user-time-balance>
          <b-card no-body fluid>
            <b-tabs pills card justified fill>
              <b-tab :title="$t('SCHEDULE')" active v-if="dataUser.personal_type == 'Employee'" >
                <personal-schedule :employee-id="dataUser.employee_id" only-view></personal-schedule>
              </b-tab>
              <b-tab title="Tab 2"
                ><b-card-text>Tab contents 2</b-card-text></b-tab
              >
              <b-tab title="Tab 3"
                ><b-card-text>Tab contents 3</b-card-text></b-tab
              >
              <b-tab title="Tab 4"
                ><b-card-text>Tab contents 4</b-card-text></b-tab
              >
              <b-tab title="Tab 5"
                ><b-card-text>Tab contents 5</b-card-text></b-tab
              >
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import UserInformation from "@/views/users/views/profile/UserInformation.vue";
import UserTimeBalance from "@/views/users/views/profile/UserTimeBalance.vue";
import UserQr from "@/views/users/views/profile/UserQr.vue";
import PersonalSchedule from "@/views/rrhh/views/employees/components/information/schedule/PersonalSchedule.vue";
import DriverInformation from "@/views/users/views/profile/DriverInformation.vue";

import { mapGetters } from "vuex";

import Ripple from "vue-ripple-directive";

export default {
  components: {
    UserInformation,
    UserTimeBalance,
    UserQr,
    PersonalSchedule,
    DriverInformation
  },
  computed: {
    ...mapGetters({
      dataUser: "auth/dataUser",
    }),
  },

  data() {
    return {};
  },
  directives: {
    Ripple,
  },
  props: {
    headerData: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss">
.profile-user{
  .card-header {
    padding: 1.5rem 1.5rem 0 1.5rem;
}
  .nav-pills{
    margin-bottom: 0 !important;
  }
}

</style>